import type { FieldValues, FormState } from 'react-hook-form';

import { checkFormServerError } from '#/lib/contact-form-client/helpers';
import { cn } from '#/lib/utils';

export function FormErrorMessage({
  formState,
  className,
}: {
  formState: FormState<FieldValues>;
  className?: string;
}) {
  const serverError = checkFormServerError(formState);

  if (!serverError) {
    return null;
  }

  return (
    <p className={cn('legal-text text-flame-06', className)}>
      {serverError.message}
    </p>
  );
}
